/**
 * Unicode normalization helpers.
 *
 * We normalize all user-supplied text to NFC (Normalization Form Canonical
 * Composition) on save. Modern browsers and keyboards usually emit NFC, but
 * iOS pasted text and some non-Latin IMEs can produce NFD (decomposed)
 * sequences. NFD breaks substring search ("café" typed by the user vs
 * "café" pasted from a PDF won't match exactly).
 *
 * Apply at save sites only. Do NOT normalize on read — existing rows may
 * be NFD until backfilled, and silently re-normalizing on read would mask
 * that.
 */
export function normalizeUserText(input: string | null | undefined): string {
  if (!input) return "";
  return input.normalize("NFC");
}

/** Same as normalizeUserText but preserves null/undefined for nullable columns. */
export function normalizeUserTextOrNull<T extends string | null | undefined>(input: T): T {
  if (input == null) return input;
  return input.normalize("NFC") as T;
}
